<div class="claims-wrapper">
  <mapfre-card [singleCard]="false" [additionalClasses]="classForPage + ' details'">
    <router-outlet></router-outlet>
  </mapfre-card>
</div>